<style lang="sass" src="./assets/scss/main.sass"></style>

<template>

  <div class="app">

    <alerts></alerts>

    <page-header></page-header>

    <div class="application main">
      <router-view class="view"></router-view>
    </div>

    <div class="footer">
      <div class="links">
        <a href="/privacypolicy">
          Privacy policy
        </a>
        <a href="http://facebook.com/507-Studio-307574720574/" target="_tab">
          <img src="./assets/img/facebook.png"/>
        </a>
        <a href="https://www.linkedin.com/company/507-?trk=company_logo" target="_tab">
          <img src="./assets/img/linkedin.png"/>
        </a>
        <a href="https://www.pinterest.com/507Studio/" target="_tab">
          <img src="./assets/img/pinterest.png"/>
        </a>
        <a href="https://www.youtube.com/channel/UC6VTe3p8oCZuAAN1WM2ecvQ" target="_tab">
          <img src="./assets/img/youtoube.png"/>
        </a>
        <a href="http://507.design/" target="_tab">
          <img src="./assets/img/web2.png"/>
        </a>
        <a href="https://www.instagram.com/507_studio/" target="_tab">
          <img src="./assets/img/instagram.png"/>
        </a>
      </div>

      <div class="pp">
        <p>
          Z oddajo tega obrazca se strinjate, da vpišemo vaše podatke v našo bazo. Vaše podatke obdelujemo skladno s
          Politiko zasebnosti, ki je objavljena na <a href="/privacypolicy">Privacy policy</a> in se bodo uporabljali
          samo za namene zaposlovanja.
          Vaši podatki bodo shranjeni v naši bazi podatkov izključno tako dolgo, kot je potrebno za te namene. Nobena
          podrobnost ne bo razkrita tretjim osebam, razen če je to zakonska zahteva. Na vašo željo bomo takoj odstranili
          vaše podatke iz naše baze podatkov. V primeru zavrnitve vaše ponudbe se stirnjate, da vase podakte ohranimo v
          naši bazi kandidatov še dve leti oz. do vašega preklica.
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
  .footer
    margin: 30px 0 0 10px

    img
      width: 25px

    .links
      text-align: center
    .pp
      margin-top: 25px
      font-size: 11px
</style>

<script>

  import PageHeader from './components/layout/header.vue';
  import Alerts from './components/layout/alerts.vue';
  import store from './vuex/store';

  export default {
    name: 'app',
    store,
    components: {
      PageHeader,
      Alerts
    }
  };


</script>



// WEBPACK FOOTER //
// App.vue?684dfc93